import React, { useState, useEffect } from "react";
import { BackNextButton, InputDisable } from "../../../../../common";
import { useGetCompanyQuery } from "../../../../../../store/Company/companyApiSlice";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ReactComponent as Verified } from "../../../../../../assets/icons/verified.svg";
import { ReactComponent as Declined } from "../../../../../../assets/icons/cancel.svg";
import { ReactComponent as Requested } from "../../../../../../assets/icons/pending.svg";
import { ReactComponent as Skipped } from "../../../../../../assets/icons/review.svg";

export const LicenseInformation = ({ onPrev, onNext, onSkip }) => {
  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token } = useSelector((state) => state.auth);
  const { data, isLoading } = useGetCompanyQuery({
    companyId: currentEditingCompany?.companyID,
    token,
  });
  const [licenseInformation, setLicenseInformation] = useState();

  useEffect(() => {
    if (data) {
      setLicenseInformation(data)
    }
  }, [data]);
  return (
    <div className="mt-5 mr-20">
      <div className="flex justify-between">
        <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2 flex">
          License Information <span className="pendingapproval">
            {

              currentEditingCompany?.trade_license_status === "Verified" ? <Verified /> : currentEditingCompany?.trade_license_status === "Declined" ?
                <Declined /> : currentEditingCompany?.trade_license_status === "Skipped" ? <Skipped /> : currentEditingCompany?.trade_license_status === "Requested" && <Requested />
            }
          </span>
        </h3>
        <div className="text-primaryText font-semibold text-f16">
          Need {" "}
          <Link to="/dashboard/help" target="_blank" rel="noopener noreferrer" className="text-link">
            Support ?
          </Link>
        </div>
      </div>
      <div className="border border-slate rounded-lg p-8 mb-6">
        <div className="flex w-full md-6 gap-4">
          <InputDisable label="Date of Establishment" value={licenseInformation?.date_of_establishment || "-"} />
          <InputDisable label="Date of Issue" value={licenseInformation?.date_of_issue || "-"} />
        </div>
        <div className="flex w-full md-6 gap-4">
          <InputDisable label="Date of Expiry" value={licenseInformation?.date_of_expiry || "-"} />
          <InputDisable label="License Number" value={licenseInformation?.license_no || "-"} />
        </div>
        <div className="flex w-full md-6 gap-4">
          <InputDisable label="Registration Body" value={licenseInformation?.registration_body || "-"} />
          <InputDisable label="Legal Form" value={licenseInformation?.legal_form || "-"} />
        </div>
        <InputDisable
          label="Activities (as per license)"
          value={licenseInformation?.activities || "-"}
        />
      </div>

      <BackNextButton
        onPrev={() => onPrev(4, "Logo & Banner", "About")}
        onNext={() => onNext(1, "Tax Information", "Details")}
        onSkip={() => onSkip(1, "Tax Information", "Details")}
      />
    </div>
  );
};
